module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.styles),
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c4100ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/Particles.vue
// module id = 2129
// module chunks = 1